import React, { useCallback, useMemo } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { Nav, NavItem, NavLink } from "reactstrap";

import { useTranslate } from "hooks";
import { useWizardActions, useWizardResultTab } from "stores/wizardStore";

export const TopologyTopBarNavigation = Scrivito.connect(() => {
  const translate = useTranslate();
  const navItems = useMemo(
    () => [
      {
        id: "summary",
        label: translate("WIZARD_SUMMARY"),
        viewName: "summary",
      },
      {
        id: "topology",
        label: translate("WIZARD_TOPOLOGY_VIEW"),
        viewName: "topology",
      },
    ],
    [translate],
  );

  const { setWizardResultTab } = useWizardActions();

  const wizardResultTab = useWizardResultTab();
  const handleViewChange = useCallback(
    (newView) => setWizardResultTab(newView),
    [setWizardResultTab],
  );

  return (
    <Nav
      tabs
      className="d-inline-flex border border-info p-1 rounded-3 flex-nowrap"
    >
      {navItems.map((item) => (
        <NavItem key={item.id}>
          <NavLink
            id={item.id}
            onClick={() => handleViewChange(item.viewName)}
            className={cx("rounded-1 cursor-pointer py-1 fs-18 lh-22", {
              "bg-blue-300 text-white": wizardResultTab === item.viewName,
              "text-blue-300": wizardResultTab !== item.viewName,
            })}
          >
            {item.label}
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
});
